/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Notifications/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import AppointmentTaken from './AppointmentTaken/index'
import Loading from './Loading/index'
import NoSlotsAvailable from './NoSlotsAvailable/index'
import None from './None/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Notifications({
  children,
  viewPath = "/App/Form/Data/ProvideData/AppointmentSlot/Notifications",
  onClickAppointmentTaken,
  onClickNextMonth
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'None'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'None'}>
<None
  viewPath={`${viewPath}/None`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Loading'}>
<Loading
  viewPath={`${viewPath}/Loading`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppointmentTaken'}>
<AppointmentTaken
  viewPath={`${viewPath}/AppointmentTaken`}
 onClick={onClickAppointmentTaken}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoSlotsAvailable'}>
<NoSlotsAvailable
  viewPath={`${viewPath}/NoSlotsAvailable`}
 onClick={onClickNextMonth}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}